export type SiteNavBadge = 'New' | 'Updated';

export type SiteNavRoute = {
  label: string;
  path: string;
  badge?: SiteNavBadge;
  /** Soft visual emphasis to draw attention (e.g. Support). */
  emphasize?: boolean;
};

export const SITE_NAV_ROUTES: readonly SiteNavRoute[] = [
  { label: 'Rules', path: '/rules' },
  { label: 'List and Leagues', path: '/profile' },
  { label: 'Support', path: '/support', badge: 'New', emphasize: true },
  { label: 'Fixtures', path: '/fixtures' },
  { label: 'Results', path: '/results' },
  { label: 'Knockout', path: '/knockout' },
  { label: 'Groups', path: '/teams' },
  { label: 'Map', path: '/map' },
  { label: 'AI League', path: '/ai-league' },
  { label: 'Stats', path: '/stats' },
];
